import React from "react";

const Donate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_11285_19583)">
        <path
          d="M3 15.15H9.10999M7.22 12.98L9.23001 14.99C9.31001 15.07 9.31001 15.21 9.23001 15.3L7.22 17.31M6.60001 21H17.4C19.38 21 21 19.38 21 17.4V6.6C21 4.62 19.38 3 17.4 3H6.60001C4.62001 3 3 4.62 3 6.6V9.3M12.57 11.69C12.57 12.52 13.21 13.18 13.99 13.18H15.59C16.27 13.18 16.82 12.6 16.82 11.88C16.82 11.11 16.48 10.83 15.98 10.65L13.42 9.76C12.92 9.58 12.58 9.31 12.58 8.53C12.58 7.82 13.13 7.23 13.81 7.23H15.41C16.19 7.23 16.83 7.89 16.83 8.72M14.7 6.37V14.03"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_19583">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Donate;
